import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class ChannelAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'channel';
	getListMessagesByChannel(id) {
		let request = {
			url: [this.getAPIUrl(), id , 'messages', ].join('/')
		};
		return httpClient.getAsync(request);
	}
	getDetailMessage(channelID, messageID) {
		let request = {
			url: [this.getAPIUrl(), channelID , messageID, ].join('/')
		};
		return httpClient.getAsync(request);
	}
}

export default new ChannelAPI();